export default class BinaryTree {
  constructor() {
    this.root = null;
  }

  insert(key, value) {
    if (this.root === null) {
      this.root = new Node(key, value);
    } else {
      let node = this.root;
      let trailingNode = null;
      while (node != null) {
        trailingNode = node;
        node = key < node.key ? node.left : node.right;
      }
      if (trailingNode == null) {
        return;
      }
      if (key < trailingNode.key) {
        trailingNode.left = new Node(key, value);
      } else {
        trailingNode.right = new Node(key, value);
      }
    }
  }

  values() {
    const values = [];
    this.forEach(value => values.push(value));
    return values;
  }

  forEach(consumer) {
    function iterateNext(root, call) {
      if (root != null) {
        iterateNext(root.left, call);
        call(root.value);
        iterateNext(root.right, call);
      }
    }

    iterateNext(this.root, consumer);
  }
}

class Node {
  constructor(key, value) {
    this.key = key;
    this.value = value;
    this.left = null;
    this.right = null;
  }
}
